





































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";

@Component
export default class SearchLocation extends Vue {
  query = "";
  isSuccess = false;
  resultLength = 0;
  locations: any = null;
  selected: any = null;

  data() {
    return {
      query: "",
    };
  }

  search() {
    this.isSuccess = false;
    axios
      .get(`https://www.yr.no/api/v0/locations/search?q=${this.query}`)
      .then((response) => {
        const result = response.data;
        this.resultLength = result.totalResults;
        if (this.resultLength > 0) {
          this.locations = result._embedded.location;
        }
        this.isSuccess = true;
      });
  }

}
